import $ from 'jquery';
import anime from 'animejs';
import slick from 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './scss/style.scss';
import './js/barChart.js';
import './js/maps3.js'

import './js/tooltip.js';


//acordeon
const $acordeonContent = $('.content');
const $acordeonItem = $('.item');
const $itemContent = $('.item-content');
let graphEixo1Open = false;

$acordeonContent.on('click', openAcordeon);

function openAcordeon() {

  let itemHeight = $(this).find('.item-content').prop('scrollHeight');
  let itemContent = $(this).find('.item-content');

  itemContent.css('height', itemHeight);

  if(itemContent.css('height') != '0px' ) {
    $('.tooltip').removeClass('show')
    itemContent.css('height', '0');
  }

  $(this).toggleClass('open');
  startScroll();

  $itemContent.on('click', stopThisPropagation);

  function stopThisPropagation(event) {
   event.stopPropagation();
  }

  if($(this).hasClass('has_graphs')) {
    graphEixo1Open = !graphEixo1Open;
  }
}

// small acordeon
const $smallAcordeonContent = $('.small_item');
const $smallAcordeonItem = $('.small_title');
const $smallItemContent = $('.small_content');

$smallAcordeonContent.on('click', openSmallAcordeon);

function openSmallAcordeon() {

  let smallItemHeight = $(this).find('.small_content').prop('scrollHeight');
  let smallItemContent = $(this).find('.small_content');

  if(smallItemContent.css('height') == '0px' ) {
    smallItemContent.css('height', smallItemHeight);
  } else {
    smallItemContent.css('height', '0');
  }

  $(this).toggleClass('open');
  
  const $thisItemContent = $(this).parents('.item-content')
  let thisItemContentHeight = parseInt($thisItemContent.css('height'))
  let newthisItemContentHeight

  if($(this).hasClass('open')) {
    newthisItemContentHeight = thisItemContentHeight + smallItemHeight
  } else {
    newthisItemContentHeight = thisItemContentHeight - smallItemHeight
  }

  $thisItemContent.css('height', newthisItemContentHeight)

  $smallItemContent.on('click', stopThisPropagation);

  function stopThisPropagation(event) {
   event.stopPropagation();
  }

}


// topButton
const $top = $('.top');

$top.on('click', toTop);
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

function toTop() {
  anime({
    targets: scrollElement,
    scrollTop: 0,
    duration: 500,
    easing: 'easeInOutQuad'
  })
}

const $menu = $('.menu-icon');

$menu.on('click', openMenu)

function openMenu() {
  $menu.toggleClass('active');
  $menu.addClass('back');
}

// make top button appear
const $window = $(window);
const $footer = $('.footer');

$window.on('scroll', startScroll);

function startScroll() {
  showTopButton();
}

function showTopButton() {
  $top.addClass('active');
}

let didScroll = false;

$window.on('scroll', checkScroll)

function checkScroll() {
  didScroll = true;

  setTimeout(() => {
    if (didScroll) {
      if( $window.scrollTop() === 0 ) {
        $top.removeClass('active');
      }
    }
    didScroll = false;
  }, 250)
}


// open plus on presentation
const $plus = $('.plus')

$plus.on('click', moreText);

function moreText() {
  $('.extra-content').addClass('active');
  $plus.addClass('hide');
}

// slick 
$('.slider').slick({
  arrows: true,
  infinite: true,
});

// timeline-horizontal
$('.timeline-horizontal').slick({
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  centerMode: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,

      }
    }
  ]
});

// eixo 2 | interactive_map_graph
const $mapRegion = $('.region')
const $mapWrapp = $('.interactive_map_graph_wrap')
const $overlay = $('.overlay')
const $closeMap = $('.close.map')
const $mapContent = $('.map_content')

$mapRegion.on('click', colorOn)

$overlay.on('click', closeMapInfo)
$closeMap.on('click', closeMapInfo)

function closeMapInfo(){
  $mapContent.removeClass('active');
  $overlay.removeClass('active');
  $mapWrapp.removeClass('active');
  $mapRegion.removeClass('on');
}

function colorOn(){
  $mapContent.removeClass('active');
  $mapRegion.removeClass('on');

  $mapWrapp.addClass('active');
  $overlay.addClass('active');
  $(this).addClass('on');
  $(`.content-${$(this).index()}`).addClass('active');
}

// eixo 1 | maternal_mortality
const $maternal_mortality = $('.maternal_mortality');
$maternal_mortality.on('click', maternal_mortality)
function maternal_mortality() {
  $('.maternal_mortality .graph').addClass('active');
}

const $graduate_students_locations = $('.graduate_students_locations');
$graduate_students_locations.on('click', graduate_students_locations)
function graduate_students_locations() {
  $('.graduate_students_locations').addClass('active');
}

// eixo 3 - map 3
const $wrap_map = $('.wrap_map');
if( $wrap_map.hasClass('active') )

$wrap_map.on('click', clickMapthree)

function clickMapthree() {
  if( $(this).hasClass('right') ) {
    $('.wrap_map.active').addClass('right');
    $('.wrap_map').removeClass('active');
    $(this).removeClass('right');
    $(this).addClass('active');
  }

  if( $(this).hasClass('left') ) {
    $('.wrap_map.active').addClass('left');
    $('.wrap_map').removeClass('active');
    $(this).removeClass('left');
    $(this).addClass('active');
  }
}

$(window).scroll(function() {
  if($('body').prop('id') == 'eixo1'){
    if(graphEixo1Open) {
      checkElements('.mother_mortality');
      checkElements('.child_mortality');
      checkElements('.fetus_mortality');
    }
  }

  if($('body').prop('id') == 'eixo2'){
    checkElements('.system')
  }

  if($('body').prop('id') == 'eixo3'){
    checkElements('.graduate_students_locations')
  }

  function checkElements(elements) {
    var top_of_element = $(elements).offset().top;
    var bottom_of_element = $(elements).offset().top + $(elements).outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
      $(elements).addClass('active');
    }
  }
});
